

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import MomentThumb from './momentThumb.vue'
import {wxShareConfig} from '../../js/common/utils'
import configInfo from "../../configInfo.js"

export default {
props: {
matchMoments: Object
},
components: {
Flexbox,
FlexboxItem,
MomentThumb
},
mounted(){
this.reload();
},
methods: {
timeStamp2HtmlString(time)
{
var datetime = new Date();
datetime.setTime(time);
var year = datetime.getFullYear();
var month = datetime.getMonth() + 1;
var date = datetime.getDate();
var hour = datetime.getHours();
var minute = datetime.getMinutes();
var second = datetime.getSeconds();
var mseconds = datetime.getMilliseconds();

var tmp = '<div>' +
'<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' +
date + ' ' +
'</div>' +
'<div style="display:inline-block;">' +
'<div style="font-family: PingFangSC-Medium;font-size: 8px;color: #333333;letter-spacing: 0;">' +
year +
'</div>' +
'<div style="font-family: PingFangSC-Medium;font-size: 8px;color: #333333;letter-spacing: 0;">' +
month + "月" +
'</div>' +
'</div>' +
'</div>';
var tmpThisYear = '<div>' +
'<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' +
date + ' ' +
'<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 8px;color: #333333;letter-spacing: 0;">' +
month + "月" +
'</div>' +
'</div>';
var tmpToday =
'<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' +
"今天" +
'</div>';
var tmpLast =
'<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' +
"昨天" +
'</div>';
var tmpFuture =
'<div style="display:inline-block;font-family: PingFangSC-Medium;font-size: 16px;color: #333333;font-weight:bold;letter-spacing: 0;">' +
"明天" +
'</div>';

var d = new Date(year, month - 1, date);
var nowDate = new Date()
var lastDate = new Date(nowDate);
lastDate.setTime(nowDate.getTime() - 24 * 60 * 60 * 1000);
var futureDate = new Date(nowDate);
futureDate.setTime(nowDate.getTime() + 24 * 60 * 60 * 1000);

if (d.toDateString() == nowDate.toDateString()) {
return tmpToday;
}
else if (d.toDateString() == lastDate.toDateString()) {
return tmpLast;
}
else if (d.toDateString() == futureDate.toDateString()) {
return tmpFuture;
}
else if (nowDate.getYear() == d.getYear()) {
return tmpThisYear;
} else {
return tmp;
}



},
getLeagueAssetUrl(assetId)
{
return this.hagkApi.getImgAssetById(assetId).url;
}
,
viewDetail(){
if (this.matchMoments && this.matchMoments.id) {
this.$router.push({
path: '/moment_list',
query: {
matchId: this.matchMoments.id
}
});
}
},
getRoundName (roundType, roundNum, roundTitle) {
var roundName = "--";

if (roundType == 'cup_1') {
roundName = "决赛"
}
else if (roundType == 'cup_2') {
roundName = "半决赛"
}
else if (roundType == 'cup_4') {
roundName = "1/4决赛"
}
else if (roundType == 'cup_8') {
roundName = "1/8决赛"
}
else if (roundType == 'cup_16') {
roundName = "1/16决赛"
}
else if (roundType == 'cup_32') {
roundName = "1/32决赛"
}
else if (roundType == 'cup_64') {
roundName = "1/64决赛"
}
else if (roundType == 'cup_128') {
roundName = "1/128决赛"
}
else if (roundType == 'cup_team' || roundType == 'league') {
roundName = "第" + roundNum + "轮"
}
else if (roundType == 'customized_rank_round') {
roundName = roundTitle
} else {
var arr = roundType.split("_")
roundName = +arr[3] + "-" + arr[2] + "名排位赛"
}
return roundName;
},
reload()
{
this.date = this.timeStamp2HtmlString(this.matchMoments.startDate);
this.roundName = " xx";
this.assets = [];
if (this.matchMoments && this.matchMoments.assetList) {
for (var i = 0; i < this.matchMoments.assetList.length; i++) {
var data = {};
data.url = this.getLeagueAssetUrl(this.matchMoments.assetList[i].assetId);
data.thumbnail_url = this.getLeagueAssetUrl(this.matchMoments.assetList[i].thumbnailId);
data.type = this.matchMoments.assetList[i].type;
this.assets.push(data)
}
}
this.homeTeamName = this.matchMoments.homeTeamName;
this.vistingTeamName = this.matchMoments.vistingTeamName;
this.roundName = this.getRoundName(this.matchMoments.round.type, this.matchMoments.round.number, this.matchMoments.round.title);

var matchObj = this.matchMoments.result;
var defaultPkScore = (matchObj.homePkScore || matchObj.visitorPkScore) ? "(0)" : "";
var homePKGoal = 0;
var visitorPKGoal = 0;
if (matchObj != undefined && matchObj != null) {
if (matchObj.homePkScore != null && matchObj.homePkScore != undefined) {
homePKGoal = matchObj.homePkScore;
}
if (matchObj.visitorPkScore != null && matchObj.visitorPkScore != undefined) {
visitorPKGoal = matchObj.visitorPkScore;
}
}

this.homeTeamScore = (matchObj != undefined && matchObj != null) ? ((matchObj.goalFor + matchObj.homeExScore + homePKGoal)) : ""
this.vistingTeamScore = (matchObj != undefined && matchObj != null) ? (matchObj.goalAgainst + matchObj.visitorExScore + visitorPKGoal) : ""
}
},
data()
{
return {
date: "今天",
roundName: "",
homeTeamName: "A",
vistingTeamName: "B",
homeTeamScore: "2",
vistingTeamScore: "3",
assets: [],
defaultImg: 'this.src="' + require('../../assets/img/no_pic.png') + '"',
videoTag: require('../../assets/img/video.png')
}
}
,
watch: {
matchMoments(curVal, oldVal)
{
this.reload();
}
}
}



// WEBPACK FOOTER //
// ./src/components/league/momentsCard.vue